<template>
	<div id="extra-wrap">
		<a class="extra-a1" href="javascript:void(0);">
			<i class="extra-i1"></i>
			客服
		</a>
		<a class="extra-a2" href="javascript:void(0);">
			<i class="extra-i2"></i>
			微信<br>公众号
			<div class="qrcode-bubble">
				<div class="qrcode">
					<div class="follow-weixin">
						<img src="../../assets/logo.png">
						<p>关注微信</p>
					</div>
				</div>
			</div>
		</a>
		<a class="extra-a3" href="javascript:void(0);">
			<i class="extra-i3"></i>
			意见<br>反馈
		</a>
		<a class="extra-a4" href="javascript:void(0);" @click="backtop">
			<i class="extra-i4 el-icon-arrow-up"></i>
		</a>
	</div>
</template>

<script>
	export default {
	    name: 'Extra',
	    data () {
	      return {
	        scrollTop: null
	      }
	    },
	    mounted(){
	      window.addEventListener('scroll', this.handleScroll, true)
	    },
	    destroyed () {
	      window.removeEventListener('scroll', this.handleScroll)
	    },
	    methods: {
	      handleScroll (ev) {
	        this.scrollTop = ev.target.documentElement.scrollTop
	      },
	      backtop () {
	        const that = this
	        let timer = setInterval(() => {
	          let ispeed = Math.floor(-that.scrollTop / 5)
	          document.documentElement.scrollTop = document.body.scrollTop = that.scrollTop + ispeed
	          if (that.scrollTop === 0) {
	            clearInterval(timer)
	          }
	        }, 16)
	      }
	    }
	  }
</script>

<style scoped>
	#extra-wrap {
	    width: 56px;
	    position: fixed;
	    right: 2px;
	    bottom: 80px;
	    z-index: 101;
	}
	#extra-wrap > a {
	    width: 54px;
	    float: left;
	    font-size: 12px;
	    color: #747474;
	    background: #fff;
	    padding-top: 9px;
	    overflow: hidden;
	    padding-bottom: 7px;
	    border-left: 1px solid #ececec;
	    border-right: 1px solid #ececec;
	    display: block;
	    text-align: center;
		transition: all 0.2s;
	}
	#extra-wrap > a:hover {
	    background: #1492ff;
	    color: #fff;
	}
	#extra-wrap  a:first-child {
	    border-top: 1px solid #ececec;
	    border-top-left-radius: 4px;
	    border-top-right-radius: 4px;
	    position: relative;
	}
	#extra-wrap a:last-child {
	    border-bottom-left-radius: 4px;
	    border-bottom-right-radius: 4px;
	    border-bottom: 1px solid #ececec;
	    position: relative;
	    overflow: visible;
	}
	#extra-wrap > a i {
	    display: block;
	    margin: 0 auto 3px;
	}
	#extra-wrap  .extra-i1 {
	    width: 26px;
	    height: 24px;
	    background: url(../../assets/icon.png) no-repeat -26px -6px;
	}
	#extra-wrap a:hover i.extra-i1 {
	    background: url(../../assets/icon.png) no-repeat 0 -6px;
	}
	#extra-wrap  .extra-i2 {
	    width: 28px;
	    height: 26px;
	    background: url(../../assets/icon.png) no-repeat -26px -60px;
	}
	#extra-wrap a:hover i.extra-i2 {
	    background: url(../../assets/icon.png) no-repeat 0 -60px;
	}
	#extra-wrap  .extra-i3 {
	    width: 24px;
	    height: 22px;
	    background: url(../../assets/icon.png) no-repeat -26px -34px;
	}
	#extra-wrap a:hover i.extra-i3 {
	    background: url(../../assets/icon.png) no-repeat 0 -34px;
	}
	#extra-wrap a i.extra-i4 {
		padding: 5px 0px;
	}
	#extra-wrap a.extra-a2:hover .qrcode-bubble {
	    display: block;
	}
	#extra-wrap .qrcode-bubble {
	    display: none;
	}
	#extra-wrap .qrcode {
	    border: 1px solid #ccc;
	    position: absolute;
	    right: 55px;
	    top: 52px;
	    width: 100px;
	    padding: 10px 0 6px 12px;
	    background-color: #fff;
	    border-radius: 3px;
	    text-align: center;
	}
	#extra-wrap .follow-weixin {
	   width: 90px;
	   color: #666;
	   margin-right: 10px;
	}
	#extra-wrap .follow-weixin img{
	   width: 90px;
	   height: 90px;
	}
</style>
